<div class="cart-add">
  <div class="item">
      <div class="content-total center">
          <div class="total" *ngIf="!produto.promocao">
                <div class="header">
                    <span>Por apenas:</span>
                </div>    
                <div class="content">
                    <span>R$</span>
                    <strong>{{valor1}}</strong>
                    <span>,{{valor2}}</span>
                </div>
          </div> 
          <div class="total" *ngIf="produto.promocao">
                <div class="header">
                    <span>De</span>
                    <strong>{{produto.valor}}</strong>
                    <span>por:</span>
                </div>    
                <div class="content">
                    <span>R$</span>
                    <strong>{{valor1}}</strong>
                    <span>,{{valor2}}</span> 
                </div>
        </div>  
      </div> 
  </div> 
  <div class="item">
      <div class="info">
          <div class="info-item" *ngIf="produto.material != null">
            <i class="fa-solid fa-gem"></i>
              <span>{{produto.material}}</span>
          </div>  
          <div class="info-item" *ngIf="produto.mostrar_parcelas"> 
              <i class="fa-solid fa-money-bill-wave"></i> 
              <span>Parcele em até {{produto.parcelas}}x sem juros.</span>
          </div>    
      </div>    
  </div> 
  <div class="item">
    <button type="button" class="btn-added btn-one btn-icon" *ngIf="inCart">
        <i class="fa-solid fa-cart-shopping"></i>
        <span>Você já adicionou este produto ao carrinho.</span>
    </button>
    <btn-add-cart *ngIf="estoque.quantidade_atual > 0 !inCart" [produto]="produto"></btn-add-cart>  
    <button (click)="openWhatsApp()" type="button" class="btn-whatsapp btn-one btn-icon" *ngIf="whatsapp != null">
        <i class="fa-brands fa-whatsapp"></i>
        <span>Falar por WhatsApp</span>
    </button>     
  </div> 
  <div class="item">  
    <partial-compra-segura></partial-compra-segura> 
  </div>    
</div>
<loader [hidden]="!loader"></loader>
